import React, { useState, useEffect, useRef, useContext } from "react";
import "./MarginInner.css";
import margin_banner from "../../../../src/Images/New_Home/images/margin_banner.png";
import margin_benefits1 from "../../../../src/Images/New_Home/images/margin_benefits-1.png";
import margin_benefits2 from "../../../../src/Images/New_Home/images/margin_benefits-2.png";
import margin_benefits3 from "../../../../src/Images/New_Home/images/margin_benefits-3.png";
import margin_benefits4 from "../../../../src/Images/New_Home/images/margin_benefits-4.png";
import margin_benefits5 from "../../../../src/Images/New_Home/images/margin_benefits-5.png";
import margin_benefits6 from "../../../../src/Images/New_Home/images/margin_benefits-6.png";

import margin_work1 from "../../../../src/Images/New_Home/images/margin_work-1.png";
import margin_work2 from "../../../../src/Images/New_Home/images/margin_work-2.png";
import margin_work3 from "../../../../src/Images/New_Home/images/margin_work-3.png";
import margin_work4 from "../../../../src/Images/New_Home/images/margin_work-4.png";
import margin_work5 from "../../../../src/Images/New_Home/images/margin_work-5.png";
import margin_work6 from "../../../../src/Images/New_Home/images/margin_work-6.png";
import margin_work from "../../../../src/Images/New_Home/images/margin_work.png";
import margin_instant1 from "../../../../src/Images/New_Home/images/margin_instant-1.png";
import margin_instant2 from "../../../../src/Images/New_Home/images/margin_instant-2.png";
import margin_instant3 from "../../../../src/Images/New_Home/images/margin_instant-3.png";
import open_account from "../../../../src/Images/New_Home/images/open-account.png";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function MarginInner() {
    window.scrollTo(0, 0);
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const { isFetching, isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

           // console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);
    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://online.moneysukh.com/',
                '_blank' 
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
  CallTrackApi("Margin Pledge",window.location.href);

    return (
        <>

            <main class="margin-main">

                <section class="margin_banner-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div className='margin_banner'>


                                    <div class="content">
                                        <div class="banner-head">
                                            Get Pledge &nbsp;
                                            <span class="text-blue">Benefits</span>
                                        </div>
                                        <p>Get pledge benefits in more than 1400+ stocks. Missing out trading opportunities due to funds shortage. Now pledge your shares and get instant funding at no cost. You can use this margin for Equity Intraday trading, futures & options selling.</p>
                                    </div>
                                    <div class="banner-img-container">
                                        <img src={margin_banner} alt="image" class="img-fluid" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="margin_benefits-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="section-heading center">
                                    Benefits of Margin Pledge
                                </div>
                                <div class="benefits-grid-container">
                                    <div class="benefits">
                                        <div class="img-container">
                                            <img src={margin_benefits1} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Know Margin
                                                Benefit Upfront</div>
                                            <p>Make informed decisions before you pledge shares for margin.</p>
                                        </div>
                                    </div>
                                    <div class="benefits">
                                        <div class="img-container">
                                            <img src={margin_benefits2} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Instant Pledge &
                                                Unpledge</div>
                                            <p>With No Capital Gain Tax if Held to Maturity* & No TDS on Interest</p>
                                        </div>
                                    </div>
                                    <div class="benefits">
                                        <div class="img-container">
                                            <img src={margin_benefits3} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Available on 1400+
                                                Stocks
                                            </div>
                                            <p>Perfect for you to do more with existing shares.</p>
                                        </div>
                                    </div>
                                    <div class="benefits">
                                        <div class="img-container">
                                            <img src={margin_benefits4} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Option Advantage Feature
                                            </div>
                                            <p>Get pledge benefits on Options Buying & Selling!</p>
                                        </div>
                                    </div>
                                    <div class="benefits">
                                        <div class="img-container">
                                            <img src={margin_benefits5} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Sell Pledged Shares
                                                at Anytime</div>
                                            <p>Get unpledged and sell your shares instantly. </p>
                                        </div>
                                    </div>
                                    <div class="benefits">
                                        <div class="img-container">
                                            <img src={margin_benefits6} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Convenient
                                                Experience</div>
                                            <p>Pledged stocks remain in your demat account.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="margin_work-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="section-heading center">
                                    How it works​?
                                </div>
                                <div class="work-container">
                                    <ul class="work-list">
                                        <li>
                                            <div class="number-container">
                                                <img src={margin_work1} alt="image" />
                                            </div>
                                            <div class="details">
                                                <p>You have:</p>
                                                <div class="amount">Rs. 50,000</div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="number-container">
                                                <img src={margin_work2} alt="image" />
                                            </div>
                                            <div class="details">
                                                <p>Position Size:</p>
                                                <div class="amount">Rs. 1,00,000</div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="number-container">
                                                <img src={margin_work3} alt="image" />
                                            </div>
                                            <div class="details">
                                                <p>Existing Holdings:</p>
                                                <div class="amount">Rs. 1,00,000</div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="number-container">
                                                <img src={margin_work4} alt="image" />
                                            </div>
                                            <div class="details">
                                                <p>Haircut:</p>
                                                <div class="amount">20%</div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="number-container">
                                                <img src={margin_work5} alt="image" />
                                            </div>
                                            <div class="details">
                                                <p>Pledge Benefit:</p>
                                                <div class="amount">Rs. 80,000</div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="number-container">
                                                <img src={margin_work6} alt="image" />
                                            </div>
                                            <div class="details">
                                                <p>Total Credit:</p>
                                                <div class="amount">50,000 +
                                                    80,000 = 1,30,000</div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="img-container">
                                        <img src={margin_work} alt="image" class="img-fluid" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <section class="margin_instant-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="section-heading center">
                                    Instant Margin Pledge Benefit for All
                                </div>
                                <div class="instant-container">
                                    <div class="instant-card">
                                        <div class="img-container">
                                            <img src={margin_instant1} alt="image" />
                                        </div>
                                        <div class="head">Intraday Traders</div>
                                        <p>Use interest free margins for Buy Today Sell Tomorrow trades.</p>
                                    </div>
                                    <div class="instant-card">
                                        <div class="img-container">
                                            <img src={margin_instant2} alt="image" />
                                        </div>
                                        <div class="head">Swing Traders</div>
                                        <p>Gain from market swings over a short time with limited funds.</p>
                                    </div>
                                    <div class="instant-card">
                                        <div class="img-container">
                                            <img src={margin_instant3} alt="image" />
                                        </div>
                                        <div class="head">Option Traders</div>
                                        <p>Every option traders can access Margin Pledge Facility!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>

                <section class="open-account-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="head">Open Your Account</div>
                                <div class="img-container">
                                    <img src={open_account} alt="image" />
                                </div>
                                <button class="bttn"  onClick={() => clickToggleLoginPopup(true)}>
                                    Get started
                                </button>
                            </div>
                        </div>
                    </div>

                </section>

                <LoginPopup show={show} ref={childRef} />

            </main>



        </>
    );
}

export default MarginInner;
